module.exports = __webpack_public_path__ + "img/trunk_8x4_z18.d915a420.svg";